import React from "react";

import { useIntl } from "react-intl";

import Funnel from "@mapmycustomers/shared/types/entity/deals/Funnel";
import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import { SelectEntityDialogProps } from "@app/component/SelectEntityDialog/selectEntityDialogFactory";
import SelectFunnelDialog from "@app/component/SelectEntityDialog/SelectFunnelsDialog";
import SelectTeamsDialog from "@app/component/SelectEntityDialog/SelectTeamsDialog";
import SelectUsersDialog from "@app/component/SelectEntityDialog/SelectUsersDialog";
import { DealsGroupByType } from "@app/scene/home/enum/DealsGroupByType";
import { DealsGroupBy } from "@app/scene/home/types/DealGroupBy";
import defaultIdGetter from "@app/util/defaultIdGetter";

import { groupByMessages } from "./messages";
import { entityNameGetter } from "./util";

type Props<T = unknown> = Omit<
  SelectEntityDialogProps<T>,
  "entities" | "getDisplayName" | "getKey" | "id" | "selectedEntities" | "title"
> & { entities: DealsGroupBy[]; selectedEntities: DealsGroupBy[] };

const UserModal: React.FC<Props<User>> = ({ entities, selectedEntities, ...props }) => {
  const intl = useIntl();
  return (
    <SelectUsersDialog
      entities={entities as User[]}
      getDisplayName={entityNameGetter[DealsGroupByType.USER]}
      getKey={defaultIdGetter}
      selectedEntities={selectedEntities as User[]}
      title={intl.formatMessage(groupByMessages[DealsGroupByType.USER])}
      {...props}
    />
  );
};

const TeamModal: React.FC<Props<Team>> = ({ entities, selectedEntities, ...props }) => {
  const intl = useIntl();
  return (
    <SelectTeamsDialog
      entities={entities as Team[]}
      getDisplayName={entityNameGetter[DealsGroupByType.TEAM]}
      getKey={defaultIdGetter}
      selectedEntities={selectedEntities as Team[]}
      title={intl.formatMessage(groupByMessages[DealsGroupByType.TEAM])}
      {...props}
    />
  );
};

const FunnelModal: React.FC<Props<Funnel>> = ({ entities, selectedEntities, ...props }) => {
  const intl = useIntl();
  return (
    <SelectFunnelDialog
      entities={entities as Funnel[]}
      getDisplayName={entityNameGetter[DealsGroupByType.FUNNEL]}
      getKey={defaultIdGetter}
      selectedEntities={selectedEntities as Funnel[]}
      title={intl.formatMessage(groupByMessages[DealsGroupByType.FUNNEL])}
      {...props}
    />
  );
};

const GroupByModal: Record<
  DealsGroupByType,
  React.FC<Props<Funnel>> | React.FC<Props<Team>> | React.FC<Props<User>>
> = {
  [DealsGroupByType.FUNNEL]: FunnelModal,
  [DealsGroupByType.TEAM]: TeamModal,
  [DealsGroupByType.USER]: UserModal,
};

export default GroupByModal;
